import { render, staticRenderFns } from "./FieldsetHandoverProtocol.yaml?vue&type=template&id=410dfb76&component"
import script from "./FieldsetHandoverProtocol.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetHandoverProtocol.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports